module.exports = {"130822100":"兴隆镇","130822101":"半壁山镇","130822102":"挂兰峪镇","130822103":"青松岭镇","130822104":"六道河镇","130822105":"平安堡镇","130822106":"北营房镇","130822107":"孤山子镇","130822108":"蓝旗营镇","130822109":"雾灵山镇","130822110":"李家营镇","130822111":"大杖子镇","130822112":"三道河镇","130822113":"蘑菇峪镇","130822114":"大水泉镇","130822200":"南天门满族乡","130822202":"八卦岭满族乡","130822203":"陡子峪乡","130822204":"上石洞乡","130822211":"安子岭乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/130822.json
// module id = 204
// module chunks = 0